<template>
  <div class="new-page-detail">
    <div class="content-box">
      <div class="new-info">
        <p class="new-title">
          {{ newDetailObj.title }}
        </p>
        <div class="works-info">
          <img :src="newDetailObj.avatar" alt="">
<!--          <img :src="newDetailObj.avatar" alt=" ">-->
          <div class="info-right">
            <p class="info-name">{{ newDetailObj.realname }}</p>
            <p class="info-watch">
              <span class="work-cate">{{ newDetailObj.cate }}</span>
              <span class="work-watch">
                <img :src="require('@/assets/num_icon_3.png')" alt="查看">
                {{ newDetailObj.read_num }}
              </span>
            </p>
          </div>
        </div>
        <div class="news-html-el" v-html="newDetailObj.text"/>
      </div>
    </div>
  </div>
</template>

<script>
import {winWorksDetail} from '@/request/api'
// import dayjs from "dayjs";

export default {
  name: "detail",
  data() {
    return {
      newDetailObj:{}
    }
  },
  computed: {},
  created() {
    this.getWorksDetailFn()
  },
  mounted() {
  },
  methods: {
    getWorksDetailFn(){
      const {id} = this.$route.query
      const requestData={
        id
      }
      winWorksDetail(requestData).then(res=>{
        let resData = res.data;
        // resData.date = dayjs(resData.created_at).format('DD/MM/YYYY')
        this.newDetailObj = resData
      })
    },
    // linkNewDetail(type){
    //   const {newDetailObj} = this;
    //   const nextId = newDetailObj[type];
    //   if(nextId){
    //     this.$router.replace({name:'newsDetail',query:{id:nextId}})
    //     this.getNewsDetailFn()
    //   }
    // }
  },
}
</script>

<style lang="scss" scoped>
  .new-page-detail {
    width: 1020px;
    margin: 0 auto;

    padding: 92px 0 140px;
    .content-box {
      width: 100%;
      .new-info {
        .new-title {
          font-size: 48px;
          font-weight: bold;
          line-height: 1.5;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
        .works-info {
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          padding-top: 25px;
          & > img {
            flex-shrink: 0;
            display: block;
            width: 57px;
            height: 57px;
            object-fit: cover;
          }
          .info-right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            padding-left: 13px;
            .info-name {
              font-size: 28px;
              font-weight: 300;
            }
            .info-watch {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-size: 12px;
              color: #999;
              .work-watch {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-left: 32px;
                & > img {
                  display: block;
                  width: 14px;
                  margin-right: 3px;
                }
              }
            }
          }
        }
        .new-img {
          width: 100%;
          padding-top: 28px;
          & > img {
            display: block;
            width: 100%;
          }
        }
        .news-html-el {
          padding: 57px 50px 0;
          font-size: 15px;
        }
      }
    }
  }
</style>
